import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 're-report-operation',
  templateUrl: './report-operation.component.html',
  styleUrl: './report-operation.component.css',
  imports: [DatePipe],
})
export class ReportOperationComponent {
  @Input({ required: true }) timestamp!: number;
  @Input({ required: true }) reportId!: string;
}
